<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import Card from 'primevue/card';
import Button from 'primevue/button';

const { t } = useI18n();

defineProps<{
  message?: string;
}>();

const emit = defineEmits<{
  retry: [];
}>();

const CARD_PT = {
  root: '!rounded-none !shadow-none',
  body: '!p-6 !pt-4 !pb-12',
} as const;

function handleRetry() {
  emit('retry');
}
</script>

<template>
  <Card class="!bg-surface-container-lowest overflow-hidden" :pt="CARD_PT">
    <template #content>
      <div class="flex flex-col items-center justify-center py-8 text-center">
        <div class="i-mdi-alert-circle text-4xl text-error mb-4" />
        <p class="text-on-surface-variant mb-4">
          {{ message || t('unableToLoadData') }}
        </p>
        <Button :label="t('tryAgain')" severity="secondary" size="small" @click="handleRetry" />
      </div>
    </template>
  </Card>
</template>
